import React, { useState } from 'react'
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../shared/utils/CustomPagination';
import { Typography } from '@mui/material';
import { useDialog } from '../../shared/hook/useDialog';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';
import CustomDivider from '../../shared/utils/CustomDivider';

const FacilityListTable = ({ facilityRows, isLoading }) => {
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
  const [paginationSubModel, setPaginationSubModel] = useState({ page: 0, pageSize: 5 });
  const { open, handleClickOpen, handleClose } = useDialog();
  const [selectedRow, setSelectedRow] = useState({});
  const facilitylistRows = selectedRow?.facilities?.map((item, index) => ({
    id: index + 1,
    sr_no: index + 1,
    ...item
  })) || [];
  const facilityColumns = [
    {
      field: "sr_no",
      headerName: "Sr No",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

    },
    //  {
    //   field: "facility_name",
    //   headerName: "Apartment Name",
    //   flex: 1,
    //   renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    // },
    {
      field: "apartment_name",
      headerName: "Apartment Name",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },

  ];

  const facilityListColumns = [
    {
      field: "sr_no",
      headerName: "Sr No",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

    },
    {
      field: "facility_name",
      headerName: "Availibility",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
    {
      field: "is_available",
      headerName: "Availibility",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
  ]

  const viewFacility = (row) => {
    setSelectedRow(row)
    handleClickOpen()
  };
  return (
    <>

      {isLoading ? (
        <DataGridSkeleton rowsNum={10} />
      ) : (
        <DataGrid
          rows={facilityRows}
          columns={facilityColumns}
          pagination
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[10]}
          disableRowSelectionOnClick={true}
          onRowClick={(params) => viewFacility(params.row)}
          slots={{
            pagination: () => (
              <CustomPagination
                paginationModel={paginationModel}
                setPaginationModel={setPaginationModel}
                totalRows={facilityRows?.length || 0}
                pageSize={paginationModel.pageSize}
              />
            ),
          }}
        />
      )}

      <MainDialogBox open={open} handleClose={handleClose} width={"60%"}>


        <Typography variant="body1" my={2}>Facility List</Typography>

        <CustomDivider />
        {isLoading ? (
          <DataGridSkeleton rowsNum={5} />
        ) : (
          <>

            <DataGrid
              rows={facilitylistRows}
              columns={facilityListColumns}
              pagination
              paginationModel={paginationSubModel}
              onPaginationModelChange={setPaginationSubModel}
              pageSizeOptions={[10]}
              slots={{
                pagination: () => (
                  <CustomPagination
                    paginationModel={setPaginationSubModel}
                    setPaginationModel={setPaginationModel}
                    totalRows={facilitylistRows?.length || 0}
                    pageSize={paginationSubModel.pageSize}
                  />
                ),
              }}
            />
          </>

        )}
      </MainDialogBox>
    </>
  )
}

export default FacilityListTable